<!--<perfect-scrollbar class="dialog-container">-->

  <h1 i18n>{{ 'form.details' | translate }}</h1>

  <div>
    <table class="table table-striped table-condensed">
      <ng-container *ngFor="let column of builder.config.columns">
        <tr *ngIf="(column.details || !column.hidden) && parse(model[column.key])">
          <td>{{ column.name }}</td>
          <td>{{ parse(model[column.key]) }}</td>
        </tr>
      </ng-container>
    </table>
  </div>

  <br>

  <div>
    <button mat-raised-button color="primary" i18n (click)="close()">{{ 'system.close' | translate }}</button>
  </div>

<!--</perfect-scrollbar>-->
